import { render, staticRenderFns } from "./youthVolunteer.vue?vue&type=template&id=a4203a1e&scoped=true&"
import script from "./youthVolunteer.vue?vue&type=script&lang=js&"
export * from "./youthVolunteer.vue?vue&type=script&lang=js&"
import style0 from "./youthVolunteer.vue?vue&type=style&index=0&id=a4203a1e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4203a1e",
  null
  
)

export default component.exports